import { type Api } from './Api';
import { BaseApi } from './BaseApi';
import { DefaultFeatureApi, type FeatureApi } from './feature';
import { DefaultPropertyApi, type PropertyApi } from './property';

export class DefaultApi extends BaseApi implements Api {
  public readonly feature: FeatureApi;
  public readonly property: PropertyApi;

  public constructor() {
    super();
    this.feature = new DefaultFeatureApi(this.queryClient);
    this.property = new DefaultPropertyApi(this.queryClient);
  }
}
